import { hDeepCopy } from '@/utils/helpers';

export const ComponentUtils = {
  data() {
    return {
      mCopy: {},
      hintModalVisible: true,
    };
  },
  methods: {
    // This method create copy of props, given in propsName arguments.
    // A copy is available in 'mCopy' object, under the props name and is reactive
    // The method should be used if we want to avoid props mutation
    mMakeCopyFromProps(propsName) {
      this.$set(this.mCopy, propsName, {});
      this.$watch(propsName, (newValue) => {
        this.$set(this.mCopy, propsName, hDeepCopy(newValue));
      }, { deep: true });
    },
  },
};

export const PopupHintsUtils = {
  data() {
    return {
      hintModalVisible: true,
    };
  },

  methods: {
    // This method checks if modal has been already shown by current user.
    // hintModalVisible is a value says if modal should be showed when user open a view
    mCheckInLocalStorageIfModalHasBeenAlreadyShown(nameInStorage) {
      if (localStorage.getItem(nameInStorage)) {
        this.hintModalVisible = false;
      } else {
        localStorage.setItem(nameInStorage, true);
      }
    },
  },
};
